var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 20.0007C40 30.102 32.5124 38.4529 22.7853 39.808C21.8758 39.9341 20.9452 40 20.0007 40C18.9104 40 17.8398 39.9131 16.7971 39.7449C7.27324 38.2118 0 29.9548 0 20.0007C0 8.95491 8.95491 0 19.9993 0C31.0437 0 40 8.95491 40 20.0007Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.787 16.0587V20.4156H28.1768L27.3233 26.2846H22.787V39.8067C21.8775 39.9328 20.947 39.9987 20.0025 39.9987C18.9122 39.9987 17.8415 39.9118 16.7989 39.7436V26.2846H11.8281V20.4156H16.7989V15.0847C16.7989 11.7774 19.4797 9.09512 22.7884 9.09512V9.09793C22.7982 9.09793 22.8067 9.09512 22.8165 9.09512H28.1782V14.171H24.6747C23.6335 14.171 22.7884 15.016 22.7884 16.0573L22.787 16.0587Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.925722cb168ff6207b96f3e76b70fe52.svg";
export { ForwardRef as ReactComponent };